import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import api from '@/lib/api';

export default function SecureExportDownload() {
  const { batch } = useParams();
  const [state, setState] = useState('loading');

  const download = async () => {
    setState('loading');
    try {
      const { data } = await api.get(`/admin/secure-exports/${batch}.zip`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([data], { type: 'application/zip' }));
      const a = document.createElement('a');
      a.href = url; a.download = `${batch}.zip`; a.click();
      window.URL.revokeObjectURL(url);
      setState('done');
    } catch (e) {
      setState(e?.response?.status === 403 ? 'denied' : 'missing');
    }
  };

  useEffect(() => { download(); }, [batch]); // eslint-disable-line react-hooks/exhaustive-deps

  const msg = { loading: 'Preparing your download…', done: 'Download started. Check your Downloads folder.',
    denied: 'Only company admins can download this file.', missing: 'This file is not available.' }[state];
  return (
    <div className="p-10 max-w-lg space-y-4" data-testid="secure-export-download">
      <h1 className="text-xl font-semibold">{batch}.zip</h1>
      <p className="text-sm text-muted-foreground" data-testid="secure-export-status">{msg}</p>
      {state !== 'loading' && state !== 'denied' && (
        <Button onClick={download} data-testid="secure-export-download-again">Download again</Button>
      )}
    </div>
  );
}
